<template>
  <el-row>
    <el-col :span="24">
      <el-card shadow="none"
               class="userinfo-main">
        <div slot="header">系统参数设置</div>
        <el-row class="main">
          <el-col :xs="24"
                  :span="18">
            <el-form ref="userInfoForm"
                     :model="userInfo"
                     :rules="rules"
                     label-width="110px">
              <el-form-item label="系统标题："
                            prop="title">
                <el-input v-model="userInfo.title"
                          placeholder="请输入系统标题"></el-input>
              </el-form-item>
              <el-form-item label="LOGO:"
                            prop="logo">
                <!-- <el-upload :action="url"
                           :headers="{ token: authId}"
                           :on-preview="handlePreview"
                           :on-remove="handleRemove"
                           :on-success="(res, file) => handleSuccess(res, file, 'logo')"
                           :file-list="logoList"
                           list-type="picture-card">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%"
                       :src="userInfo.logo"
                       alt="" />
                </el-dialog> -->
                <el-upload class="single-uploader"
                           accept=".jpg, .jpeg, .png"
                           :action="imgUpUrl"
                           :headers="{ token: authId }"
                           :show-file-list="false"
                           :before-upload="beforeAvatarUpload"
                           :on-success="(res, file) => handleSuccess(res, file, 'logo')">
                  <img v-if="userInfo.logo"
                       :src="imgDownUrl + userInfo.logo"
                       class="single-img" />
                  <i v-else
                     class="el-icon-plus single-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="登录界面图片："
                            prop="back">
                <!-- <el-upload :action="url"
                           :headers="{ token: authId}"
                           :on-preview="handlePreview"
                           :on-remove="handleRemove"
                           :on-success="(res, file) => handleSuccess(res, file, 'login')"
                           :file-list="loginList"
                           list-type="picture-card">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%"
                       :src="userInfo.back"
                       alt="" />
                </el-dialog> -->
                <el-upload class="single-uploader"
                           accept=".jpg, .jpeg, .png"
                           :action="imgUpUrl"
                           :headers="{ token: authId }"
                           :show-file-list="false"
                           :on-success="(res, file) => handleSuccess(res, file, 'login')">
                  <img v-if="userInfo.back"
                       :src="imgDownUrl + userInfo.back"
                       class="single-img" />
                  <i v-else
                     class="el-icon-plus single-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="设备密钥："
                            prop="code_key">
                <el-input disabled
                          v-model="userInfo.code_key"
                          placeholder="请输入设备密钥"></el-input>
              </el-form-item>
              <el-form-item label="本地码："
                            prop="code_local">
                <el-input disabled
                          v-model="userInfo.code_local"
                          placeholder="请输入本地码"></el-input>
              </el-form-item>
              <el-form-item label="授权码："
                            prop="code_auth">
                <el-input v-model="userInfo.code_auth"
                          placeholder="请输入授权码"></el-input>
              </el-form-item>
              <el-form-item label="授权设备数量："
                            prop="lock_auth_count">
                <el-input disabled
                          v-model="userInfo.lock_auth_count"
                          placeholder="请输入授权设备数量"></el-input>
              </el-form-item>
              <div class="alignCenter">
                <el-button v-has="'/dict/batch_del'"
                           type="primary"
                           @click="handleSave('userInfoForm')">
                  确 定
                </el-button>
              </div>
            </el-form>
          </el-col>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
export default {
  data() {
    return {
      imgUpUrl: fetch.uploadImgUrl,
      imgDownUrl: fetch.downImgUrl,
      authId: localStorage.getItem('token'),
      logoList: [],
      loginList: [],
      userInfo: {
        title: '',
        logo: '',
        back: '',
        code_key: '',
        code_local: '',
        code_auth: '',
        lock_auth_count: ''
      },
      rules: {
        code_local: [{ required: false, message: '请输入昵称' }]
      },
      // 图片预览弹窗
      dialogVisible: false
    }
  },
  created() {
    this.getSysInfo()
  },
  methods: {
    getSysInfo() {
      fetch.getSysInfo({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.userInfo = data
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    beforeAvatarUpload(file) {
      const isLt500K = file.size / 1024 < 500
      if (!isLt500K) {
        this.$message.error('上传头像图片大小不能超过 500K!')
      }
      return isLt500K
    },
    handleSuccess(res, file, type) {
      if (type === 'logo') {
        this.userInfo.logo = res.result.file_url
      } else {
        this.userInfo.back = res.result.file_url
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      this.userInfo.back = file.url
      this.dialogVisible = true
    },
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch.setSysInfo({ ...this.userInfo }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                localStorage.setItem('logo', this.userInfo.logo)
                this.getSysInfo()
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.userinfo-main {
  border-top: 4px solid #001938;
  .main {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}
</style>
